import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SidebarComponent from "../components/Sidebar";
import Dashboard from "../pages/Dashboard";
import Ingredients from "../pages/Ingredents";
import Orders from "../pages/Orders";
import OrderDetails from "../pages/OrderDetails";
import NewOrder from "../pages/NewOrder";
import Products from "../pages/Products";
import Summary from "../pages/Summary";
import DynamicOrderForm from "../components/DynamicOrderForm/DynamicOrderForm";
import DeliveryNotePrint from "../components/DeliveryNotePrint";
import Login from "../pages/Login";
import { AuthProvider } from "../components/shared/AuthContext";
import { ProtectedRoute } from "../components/shared/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/custom.css";

const Main: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <SidebarComponent>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/ingredients" element={<Ingredients />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/orders/new" element={<NewOrder />} />
                    <Route path="/orders/view/:id" element={<DynamicOrderForm />} />
                    <Route path="/orders/:id" element={<OrderDetails />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/summary" element={<Summary />} />
                  </Routes>
                </SidebarComponent>
              </ProtectedRoute>
            }
          />

          {/* Print route — protected but no sidebar */}
          <Route
            path="/orders/print/:id"
            element={
              <ProtectedRoute>
                <DynamicOrderForm />
              </ProtectedRoute>
            }
          />

          {/* Delivery Note print route — protected, no sidebar */}
          <Route
            path="/orders/delivery-note/:id"
            element={
              <ProtectedRoute>
                <DeliveryNotePrint />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default Main;
